import { render } from "./header.vue?vue&type=template&id=4f6e6220&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=4f6e6220&scoped=true&lang=scss"
import "./header.vue?vue&type=style&index=1&id=4f6e6220&lang=css"

import exportComponent from "E:\\object\\源制汇产能共享公共服务平台\\boyaokj-enyuan-yuanliancloud-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6e6220"]])

export default __exports__